import './administrative-dashboard';
import './manage-activity-type-list';
import './manage-point-inaccuracy-list.js';
import './manage-media-list';
import './manage-organization-list';
import './manage-pet-list';
import './manage-promotion-code-list';
import './manage-product-list';
import './manage-purchase-location-list';
import './manage-redemption-list';
import './manage-reward-list';
import './manage-salesforce-import-list';
import './manage-transaction-list';
import './manage-user-list';
import './manage-user-activity-list';
import './manage-white-list';
import './user-profile';
import './components';
import './story-list';
